<div id="orders" class="page-layout carded fullwidth inner-scroll">
  <!-- TOP BACKGROUND -->
  <div class="top-bg accent"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">
    <!-- HEADER -->
    <div class="flex flex-col justify-center items-center sm:flex-row sm:justify-between header accent">
      <!-- APP TITLE -->
      <div class="flex flex-row items-center logo mb-6 sm:mb-0">
        <mat-icon class="logo-icon s-32 mr-4" [@animate]="{ value: '*', params: { delay: '50ms', scale: '0.2' } }">
          shopping_basket
        </mat-icon>
        <span class="logo-text h1" [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
          <span i18n *ngIf="isArchivePage">Архив заказов</span>
          <span i18n *ngIf="!isArchivePage">Заказы</span>
        </span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-wrapper sm:ml-2">
        <div class="search flex flex-1 flex-row items-center">
          <mat-icon>search</mat-icon>
          <input
            #filter
            i18n-placeholder
            [value]="filters.searchText"
            (keyup)="updateQueryParams({ searchText: $any($event.target).value })"
            placeholder="Поиск" />
        </div>
      </div>
      <!-- / SEARCH -->

      <div class="flex flex-row items-center gap-3" *ngIf="mbExist$ | async as matBaseExist">
        <button
          data-testid="addOrderButton"
          *ngIf="!selectionMode"
          [disabled]="!matBaseExist || !agreementState"
          (click)="goToNewOrder()"
          mat-raised-button
          class="add-product-button mat-white-bg">
          <span i18n>ДОБАВИТЬ ЗАКАЗ</span>
        </button>

        <ng-container *ngIf="selectionMode">
          <button (click)="uniteOrders()" mat-raised-button class="add-product-button mat-accent-bg">
            <span i18n>ОБЪЕДИНИТЬ</span>
          </button>
          <button (click)="uniteCancel()" mat-raised-button class="add-product-button mat-white-bg">
            <span i18n>ОТМЕНА</span>
          </button>
        </ng-container>

        <button [disabled]="!matBaseExist || !agreementState" mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button [disabled]="selectionMode" i18n (click)="uniteOrdersMode()" mat-menu-item>Объединить заказы</button>
        </mat-menu>
      </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card">
      <mat-table
        *ngIf="data$ | async as data"
        class="orders-table"
        #table
        [dataSource]="data"
        matSort
        [matSortActive]="filters.active"
        [matSortDirection]="filters.direction"
        (matSortChange)="updateQueryParams({ active: $event.active, direction: $event.direction })">
        <!-- Selection Column -->
        <ng-container cdkColumnDef="selection">
          <mat-header-cell i18n *cdkHeaderCellDef> </mat-header-cell>
          <mat-cell *cdkCellDef="let order">
            <mat-checkbox
              [disabled]="isConfirmedOrder(order)"
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(order.id) : null"
              [checked]="selection.isSelected(order.id)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container cdkColumnDef="name">
          <mat-header-cell mat-sort-header i18n *cdkHeaderCellDef class="hidden sm:flex">№ Заказа</mat-header-cell>
          <mat-cell *cdkCellDef="let order" class="hidden sm:flex">
            <p class="text-truncate">{{ order.name }}</p>
          </mat-cell>
        </ng-container>

        <!-- FactoryOrderId Column -->
        <ng-container cdkColumnDef="factoryOrderId">
          <mat-header-cell mat-sort-header i18n *cdkHeaderCellDef class="hidden sm:flex"
            >Производственный номер</mat-header-cell
          >
          <mat-cell *cdkCellDef="let order" class="hidden sm:flex">
            <p class="text-truncate">{{ order.factoryOrderId }}</p>
          </mat-cell>
        </ng-container>

        <!-- Total Price Column -->
        <ng-container cdkColumnDef="amount">
          <mat-header-cell mat-sort-header i18n *cdkHeaderCellDef class="hidden md:flex">Сумма</mat-header-cell>
          <mat-cell *cdkCellDef="let order" class="hidden md:flex">
            <p class="total-price text-truncate">
              {{ order.amount | formatNumber : 2 | formatCurrency }}
            </p>
          </mat-cell>
        </ng-container>

        <!-- Note Column -->
        <ng-container cdkColumnDef="note">
          <mat-header-cell i18n *cdkHeaderCellDef class="hidden sm:flex">Примечание</mat-header-cell>
          <mat-cell *cdkCellDef="let order" class="hidden sm:flex">
            <p class="text-truncate">
              {{ order.note }}
            </p>
          </mat-cell>
        </ng-container>

        <!-- Note Column -->
        <ng-container cdkColumnDef="clientNote">
          <mat-header-cell i18n *cdkHeaderCellDef class="hidden sm:flex">Внутренний комментарий</mat-header-cell>
          <mat-cell *cdkCellDef="let order" class="hidden sm:flex">
            <p class="text-truncate">
              {{ order.clientNote }}
            </p>
          </mat-cell>
        </ng-container>

        <!-- Status Column -->
        <ng-container cdkColumnDef="statusName">
          <mat-header-cell mat-sort-header i18n *cdkHeaderCellDef class="hidden sm:flex">Статус</mat-header-cell>
          <mat-cell *cdkCellDef="let order" class="hidden sm:flex">
            <p class="status text-truncate h6 p-1">
              <span *ngIf="order.status.isDefault">{{ order.status.action | defaultCuttingOrderStatusName }}</span>
              <span *ngIf="!order.status.isDefault">{{ order.status.name }}</span>
            </p>
          </mat-cell>
        </ng-container>

        <!-- Date Column -->
        <ng-container cdkColumnDef="dateCreate">
          <mat-header-cell mat-sort-header i18n *cdkHeaderCellDef class="hidden sm:flex">Дата</mat-header-cell>
          <mat-cell *cdkCellDef="let order" class="hidden sm:flex">
            <p class="text-truncate">
              {{ order.dateCreate | date : 'dd.MM.yyyy' }}
            </p>
          </mat-cell>
        </ng-container>

        <!-- DateEdit Column -->
        <ng-container cdkColumnDef="dateEdit">
          <mat-header-cell mat-sort-header i18n *cdkHeaderCellDef>Дата изменения</mat-header-cell>
          <mat-cell *cdkCellDef="let item">
            {{ item.dateEdit | date : 'shortDate' }}
          </mat-cell>
        </ng-container>

        <!-- DateOfIssue Column -->
        <ng-container cdkColumnDef="dateOfIssue">
          <mat-header-cell mat-sort-header i18n *cdkHeaderCellDef>Дата выдачи</mat-header-cell>
          <mat-cell *cdkCellDef="let item">
            {{ item.dateOfIssue | date : 'shortDate' }}
          </mat-cell>
        </ng-container>

        <!-- PlannedDateOfIssue Column -->
        <ng-container cdkColumnDef="plannedDateOfIssue">
          <mat-header-cell mat-sort-header i18n *cdkHeaderCellDef>Планируемая дата выдачи</mat-header-cell>
          <mat-cell *cdkCellDef="let item">
            {{ item.plannedDateOfIssue | date : 'shortDate' }}
          </mat-cell>
        </ng-container>

        <!-- Menu Column -->
        <ng-container cdkColumnDef="menu">
          <mat-header-cell *cdkHeaderCellDef>
            <button mat-icon-button [matMenuTriggerFor]="headerMenu">
              <mat-icon class="mat-24" aria-label="">more_vert</mat-icon>
            </button>
            <mat-menu #headerMenu="matMenu">
              <button mat-menu-item (click)="openFieldSettingsDialog()">
                <span i18n>Настройка столбцов</span>
              </button>
            </mat-menu>
          </mat-header-cell>
          <mat-cell *cdkCellDef="let order">
            <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
              <mat-icon class="mat-24">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="toggleArchived(order)">
                <span i18n *ngIf="isArchivePage">Извлечь из архива</span>
                <span i18n *ngIf="!isArchivePage">Переместить в архив</span>
              </button>
              <button *ngIf="!isArchivePage" mat-menu-item i18n (click)="createOrderCopy(order.id)"
                >Создать копию заказа</button
              >
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

        <mat-row
          *cdkRowDef="let order; columns: displayedColumns"
          class="order"
          matRipple
          [routerLink]="['/order/detail/' + order.id]">
        </mat-row>
      </mat-table>

      <mat-paginator
        #paginator
        [length]="totalCount"
        [pageIndex]="filters.pageIndex"
        [pageSize]="filters.pageSize"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="updateQueryParams({ pageIndex: $event.pageIndex, pageSize: $event.pageSize })">
      </mat-paginator>
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
